import { AudioManager, AudioType } from '@colonist/audio';
export const runWithClickSound = (action)=>{
    return (...args)=>{
        AudioManager.play(AudioType.Click);
        void action(...args);
    };
};
